const STORAGE_KEY = 'teammak.audio-playback-position';

interface PlaybackPosition {
  trackId: string;
  secondsListened: number;
}

/** Local mirror of the play progress for the track currently in the player.
 * Firestore writes are async and never land when Android kills the PWA
 * mid-playback; this write is synchronous, so it survives the kill and is what
 * the player resumes from on the next cold start. Only the active track is
 * kept, so the player publishes an outgoing track's position to Firestore
 * before swapping in a new one. */
export function storePlaybackPosition(position: PlaybackPosition) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(position));
  } catch {
    /** Full or unavailable storage still leaves Firestore as the fallback. */
  }
}

export function readPlaybackPosition(trackId: string) {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return undefined;

    const position: PlaybackPosition = JSON.parse(stored);
    if (position.trackId !== trackId) return undefined;

    return position;
  } catch {
    return undefined;
  }
}

export function clearPlaybackPosition(trackId: string) {
  if (!readPlaybackPosition(trackId)) return;
  localStorage.removeItem(STORAGE_KEY);
}
